import { render } from "./SuperAdminDatatableTDNewVersion.vue?vue&type=template&id=10752a6c"
import script from "./SuperAdminDatatableTDNewVersion.vue?vue&type=script&lang=js"
export * from "./SuperAdminDatatableTDNewVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__